// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "assets/js/" + chunkId + "." + {"191":"23d61288","255":"3a92e22e","293":"9b0c72c0"}[chunkId] + ".js";
};